<template>
  <router-link
    class="hm-link"
    :to="to"
    :event="isBlocked ? [] : 'click'"
    :aria-disabled="isBlocked ? 'true' : null"
    :style="{ background, color }"
    @click="onClick"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span v-if="loading" aria-hidden="true" class="hm-link__spinner"></span>
    <slot v-else/>
  </router-link>
</template>

<script>
export default {
  name: 'HMLinkButton',
  props: {
    to: { type: [Object, String], required: true },
    background: { type: String, default: 'linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%)' },
    color: { type: String, default: '#698262' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    isBlocked() { return this.loading || this.disabled }
  },
  methods: {
    onClick(e) {
      if (this.isBlocked) {
        e.preventDefault()
        e.stopImmediatePropagation()
        e.stopPropagation()
      }
    },
  },
}
</script>

<style>
.hm-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 57px;
  height: 36px;
  padding: 5px 12px;
  border-radius: 8px;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  transition: filter 0.3s;
  text-decoration: none;
}

.hm-link:hover {
  filter: brightness(0.95);
}

.hm-link[aria-disabled="true"] {
  opacity: .6;
  pointer-events: none;
}

.hm-link__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #d5d4d4;
  border-top-color: #6ec1ff;
  border-radius: 50%;
  animation: hc-spin .8s linear infinite;
}

@keyframes hc-spin {
  to {
    transform: rotate(360deg)
  }
}
</style>
